module.exports = __webpack_public_path__ + "static/media/icon-patrick-star.9dd870a0.svg";